import SingleSelectBox from "../FormComponents/SingleSelectBox";
import EditRecordviewOnScreenFilters from "../../Pages/ApplicationBlock/RecordsViewRenderer/Desktop/RecordsViewEdit/EditRecordviewOnScreenFilters";

const EditRvFilterForPosition = ({ editElementData, setEditElementData, tableId, tableType }) => {
  const handleChange = (l) => {
    setEditElementData({ ...editElementData, layout: l.id });
  };
  const handleChangeFilters = (d) => {
    setEditElementData({ ...editElementData, filters: d });
  };
  return (
    <>
      <SingleSelectBox
        options={[
          { id: "horizontal", name: "Horizontal" },
          { id: "vertical", name: "Vertical" }
        ]}
        selectedData={editElementData.layout}
        onChange={handleChange}
        label="Layout"
        containerClassName="mb_2"
      />
      <EditRecordviewOnScreenFilters
        filters={editElementData.filters}
        saveFilters={handleChangeFilters}
        tableId={tableId}
        tableType={tableType}
      />
    </>
  );
};

export default EditRvFilterForPosition;
